import React from 'react';
import PropTypes from 'prop-types';
import { I18N } from 'commons';

const EffectedAreas = ({ text }) => (
  <p className="areas-bg">
    <I18N>weather.label.affectedAreas</I18N>:
    <span
      className="affected-areas"
      eb-test="ee_weatherAlertDetail_text_affectedAreas"
    >
      {text}
    </span>
  </p>
);

EffectedAreas.propTypes = {
  text: PropTypes.string.isRequired,
};

export default EffectedAreas;
